import axiosBase from 'axios';
import { attachAutoRefresh } from '@/lib/apiClient';

// Master admins have no schedule of their own: support looks at one customer account at a time.
// The account chosen in the picker is added to every schedule request as ?account_id=...
let viewingAccount = null;
export const setViewingAccount = (id) => { viewingAccount = id || null; };
export const getViewingAccount = () => viewingAccount;

export function makeClient() {
  const c = axiosBase.create({ withCredentials: true });
  c.interceptors.request.use((cfg) => {
    if (viewingAccount) cfg.params = { ...(cfg.params || {}), account_id: viewingAccount };
    return cfg;
  });
  attachAutoRefresh(c);
  return c;
}
